export default function Footer() {
  return (
    <footer className="text-center p-6 bg-black text-white pt-24 p-12 ">
      © 2026 Cricket Academy | All Rights Reserved
    </footer>
  );
}